import React, { useEffect, useState } from "react";
import { Button, Grid, Header } from "semantic-ui-react";
import FotoWidgetCropper from "./FotoWidgetCropper";
import FotoWidgetDropzone from "./FotoWidgetDropzone";
import "../../../features/profiles/ProfileFotos.css"

interface Props {
    loading : boolean;
    uploadFoto: (file: Blob) => void;
}

export default function FotoUploadWidget({loading, uploadFoto} : Props) {
    const [files, setFiles] = useState<any>([]);
    const [cropper, setCropper] = useState<Cropper>();

    function onCrop() {
        if (cropper) {
            cropper.getCroppedCanvas().toBlob(blob => uploadFoto(blob!));
        }
    }

    useEffect( () => {
        return () => {
            files.forEach((file: any) => URL.revokeObjectURL(file.preview))
        }
    }, [files])

    return (
        <Grid>
            <Grid.Column width={4}>
                <Header sub color='teal' content='Paso 1 - Agregar fotografía' />
                <FotoWidgetDropzone setFiles={setFiles} />
            </Grid.Column>
            <Grid.Column width={1} />
            <Grid.Column width={4}>
                <Header sub color='teal' content='Paso 1 - Ajustar tamaño' />
                {files && files.length > 0 && (
                    <FotoWidgetCropper setCropper={setCropper} imagePreview={files[0].preview} />
                )}
            </Grid.Column>
            <Grid.Column width={1} />
            <Grid.Column width={4}>
                <Header sub color='teal' content='Paso 1 - Vista previa y cargar' />
                {files && files.length > 0 &&
                <>
                <div className='img-preview' style={{minHeight: 200, overflow: 'hidden'}} />
                <Button.Group widths={2}>
                    <Button className="boton-cerrar" disabled={loading} onClick={() => setFiles([])} color="red" icon='close' />
                    <Button className="boton-confirmar" loading={loading} onClick={onCrop} positive icon='check' />
                </Button.Group>
                </>}
            </Grid.Column>
        </Grid>
    )
}